import React from 'react';

import './progress-bar.styl'

function ProgressBar(props) {
  return (
    <div className="ac-progress-bar">
      <span className="ac-progress-bar__min">{props.min}</span>
      <div className="ac-progress-bar__progress" style={{width: `${(props.value/props.max)*100}%`}} />
      <span className="ac-progress-bar__max">{props.max}</span>
    </div>
  );
}

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/components/progress-bar/ProgressBar.js